export default __webpack_public_path__ + "static/media/lesson.4f40bf05.svg";